import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerUnion } from '@adornis/baseql/metadata/register.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { LogicExpression } from '@chancenwerk/enums/enums.js';
import { FormOfFinancing } from '../../../_cms/financing/entities/FormOfFinancing.js';

export const FormOfFinancingLogicExpressionArrayUnion = registerUnion({
  name: 'FormOfFinancingLogicExpressionArrayUnion',
  types: () => [FormOfFinancingLogicExpression, FormOfFinancing],
});

/**
 * @entity FormOfFinancingLogicExpression
 */
@Entity()
export class FormOfFinancingLogicExpression extends AdornisEntity {
  public static override _class = 'FormOfFinancingLogicExpression';

  constructor(doc: Partial<EntityData<FormOfFinancingLogicExpression>>) {
    super(doc);
  }

  public static override get allFields() {
    return selectionSet(() => this, 5);
  }

  @Field(() => ID, {
    default: v => {
      return v ?? A.getGloballyUniqueID();
    },
  })
  public _id: Maybe<string>;

  @Field(() => LogicExpression)
  public type: Maybe<LogicExpression>;

  @Field(() => [FormOfFinancingLogicExpressionArrayUnion], { default: v => v ?? [] })
  public formsOfFinancingArray: Maybe<Array<Maybe<FormOfFinancingLogicExpression | FormOfFinancing>>>;

  override toString() {
    if (this.type === LogicExpression.AND)
      return `${this.formsOfFinancingArray?.map(f => f?.toString() ?? '').join(' UND ')}`;
    if (this.type === LogicExpression.OR)
      return `${this.formsOfFinancingArray?.map(f => f?.toString() ?? '').join(' ODER ')}`;
  }
}
